import type { Direction } from './types'

/**
 * SafheNet is RTL-first: if the document does not explicitly declare a
 * direction, we assume RTL (Persian) rather than defaulting to LTR.
 */
export function detectDirection(explicit?: Direction): Direction {
  if (explicit === 'rtl' || explicit === 'ltr')
    return explicit

  const docDir = document.documentElement.getAttribute('dir')
  if (docDir === 'ltr')
    return 'ltr'
  if (docDir === 'rtl')
    return 'rtl'

  const computed = getComputedStyle(document.documentElement).direction
  if (computed === 'ltr')
    return 'ltr'

  // Default: RTL-first
  return 'rtl'
}
